export default "__VITE_ASSET__Ceo6lMgC__"